import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Checkbox,
  Box,
  Input,
  IconButton,
  Flex,
  Image,
} from "@chakra-ui/react";
import { useState } from "react";
import Adjustments from "../../assets/waveflowmain/aiobservability/Adjustments.png";
import Download from "../../assets/waveflowmain/aiobservability/Download.png";
import Refresh from "../../assets/waveflowmain/aiobservability/Refresh.png";
import Search from "../../assets/waveflowmain/aiobservability/Search.png";
import { commonStyle } from "../../styles/commonStyle";

const WorkflowsTable = ({ workflows }) => {
  const [search, setSearch] = useState("");
  const [checkIdBox, setCheckIdBox] = useState([]);

  const filtered = workflows?.filter((item) =>
    item.session_id.toLowerCase().includes(search.toLowerCase())
  );

  const checkboxHandle = (id) => {
    setCheckIdBox((prev) =>
      checkIdBox.includes(id)
        ? checkIdBox.filter((ele) => ele !== id)
        : [...prev, id]
    );
  };
  return (
    <Box h={"100%"} borderWidth="1px" borderRadius="md" p={4}>
      <Flex justify={"flex-end"} mb={3}>
        <Input
          placeholder="Search..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          maxW="300px"
          size={"sm"}
        />
        <Flex gap={0}>
          <IconButton
            aria-label="Delete"
            icon={<Image src={Search} w={"15px"} />}
            size="sm"
            variant="ghost"
          />
          <IconButton
            aria-label="Delete"
            icon={<Image src={Adjustments} w={"15px"} />}
            size="sm"
            variant="ghost"
          />
          <IconButton
            aria-label="Delete"
            icon={<Image src={Download} w={"15px"} />}
            size="sm"
            variant="ghost"
          />
          <IconButton
            aria-label="Delete"
            icon={<Image src={Refresh} w={"15px"} />}
            size="sm"
            variant="ghost"
          />
        </Flex>
      </Flex>

      <Box
        h={"90%"}
        overflowY="auto"
        sx={{ ...commonStyle.sx, scrollBehavior: "smooth" }}
      >
        <Table variant="simple" size="sm">
          <Thead position="sticky" top="0" bg="gray.100" zIndex="1">
            <Tr>
              <Th>
                <Checkbox />
              </Th>
              <Th>Session ID</Th>
              <Th>Client</Th>
              <Th>Model</Th>
              <Th>Agents Created</Th>
              <Th>Date</Th>
              <Th>Session Tokens</Th>
            </Tr>
          </Thead>
          <Tbody>
            {filtered?.map((row, idx) => (
              <Tr key={idx} bg={checkIdBox.includes(idx) ?"gray.300":""}>
                <Td>
                  <Checkbox checked={checkIdBox.includes(idx)} onChange={() => checkboxHandle(idx)} />
                </Td>
                <Td>{row?.session_id}</Td>
                <Td>{row?.client}</Td>
                <Td>{row.model_name}</Td>
                <Td>{row?.num_agents}</Td>
                <Td>{row?.date}</Td>
                <Td>{row?.session_tokens}</Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>
    </Box>
  );
};

export default WorkflowsTable;
